export default __webpack_public_path__ + "static/media/more-20-px.8bd87a14.svg";